import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import NavLogo from '../NavLogo';
import '../NavLogo/account-menu.css';
import './navbar.css';
import { canAccessAR } from '../../services/ar';
import { UserContext } from '../../context/UserProvider.jsx';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// const pages = ['Customers', 'Orders', 'Products', 'Invoices', 'Users'];
const settings = ['Logout'];
const pagePath = page => page === 'ACCOUNT RECEIVABLE' ? '/accounts-receivable' : '/' + page.toLowerCase();

function ResponsiveAppBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = page => pathname === pagePath(page) || pathname.startsWith(pagePath(page) + '/');
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const { logout, access, userType } = React.useContext(UserContext);
  const [pages, setPages] = React.useState(null);

  React.useEffect(() => {
    if (access) {
      const pagesTemp = [];
      const acl = access.control;
      for (const key in acl) {
        if (acl[key] === true) {
          if (
            key !== 'admin'
            && key !== 'sales person'
            && key !== 'customer onboarder'
            && key !== 'customer - sales person reassign'
            && !key.includes('user specific')
          ) {
            pagesTemp.push(key.toLocaleUpperCase());
          }
        }
      }

      pagesTemp.reverse();
      if (canAccessAR(access, userType)) {
        const invoiceIndex = pagesTemp.indexOf('INVOICES');
        pagesTemp.splice(invoiceIndex >= 0 ? invoiceIndex + 1 : pagesTemp.length, 0, 'ACCOUNT RECEIVABLE');
      }
      setPages(pagesTemp);
    }
  }, [access, userType]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSettingClick = (setting) => () => {
    if (setting === 'Logout') {
      logout();
      navigate('/');
    } else if (setting === 'Users') {
      navigate('/users');
    }
  }

  const handleNavigate = (page) => () => {
    setAnchorElNav(null);
    navigate(pagePath(page));
  }

  if (!pages) {
    return null;
  }

  return (
    <AppBar className="store2door-navbar" position="static" sx={{ bgcolor: '#1565c0', color: '#fff' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <NavLogo />

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="Open navigation"
              aria-expanded={Boolean(anchorElNav)}
              aria-controls="primary-navigation-menu"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="primary-navigation-menu"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} selected={isActive(page)} aria-current={isActive(page) ? 'page' : undefined} onClick={handleNavigate(page)} sx={{ minHeight: 48 }}>
                    <Typography textAlign="center">{page === 'ACCOUNT RECEIVABLE' ? 'Account Receivable' : page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <NavLogo mobile />
          <Box component="nav" aria-label="Primary navigation" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, gap: 1 }}>
            {pages.map((page) => (
              <Button
                key={page}
                component={Link}
                to={pagePath(page)}
                aria-current={isActive(page) ? 'page' : undefined}
                className="primary-nav-link"
                sx={{ my: 1, px: 2, minHeight: 44, borderRadius: 2 }}
              >
                {page === 'ACCOUNT RECEIVABLE' ? 'Account Receivable' : page.charAt(0) + page.slice(1).toLowerCase()}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton aria-label="Open settings" aria-controls={anchorElUser ? "account-menu" : undefined} aria-expanded={Boolean(anchorElUser)} aria-haspopup="true" onClick={handleOpenUserMenu} sx={{ p: .5, color: "inherit" }}>
                <Avatar alt="User" src="https://static.vecteezy.com/system/resources/previews/000/574/512/original/vector-sign-of-user-icon.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              PaperProps={{ className: 'nav-account-menu' }}
              MenuListProps={{ 'aria-label': 'Account settings' }}
              id="account-menu"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleSettingClick(setting)}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
